import { Routes, Route } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import { PublicLayout, AppLayout } from "@/components/layout";
import Login from "@/pages/Login";
import Home from "@/pages/Home";
import Companies from "@/pages/Companies";
import CompanyDetail from "@/pages/CompanyDetail";
import Reviews from "@/pages/Reviews";
import Account from "@/pages/Account";

export const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/companies" element={<Companies />} />
        <Route path="/companies/:id" element={<CompanyDetail />} />
      </Route>
      <Route element={<ProtectedRoute />}>
        <Route element={<AppLayout />}>
          <Route path="/reviews" element={<Reviews />} />
          <Route path="/account" element={<Account />} />
        </Route>
      </Route>
    </Routes>
  );
};
